import React from "react";
import "../styles/AboutCTA.css";

const AboutCTA = () => {
  return (
    <section className="about-cta-section">
      <div className="about-cta-container">

        <div className="about-cta-left">
          <h2>Ready to find your legal expert?</h2>

          <p>
            Join thousands of people who have found the right solicitor
            through our trusted platform.
          </p>

          <div className="about-cta-actions">
            <button
              className="about-cta-primary"
              onClick={() => (window.location.href = "/search")}
            >
              Start Your Search
            </button>

            <button
              className="about-cta-secondary"
              onClick={() => (window.location.href = "/contact")}
            >
              Contact Support
            </button>
          </div>
        </div>

        <div className="about-cta-right">
          <img
            src="/Home/cta2.png"
            alt="Legal expert support"
          />
        </div>

      </div>
    </section>
  );
};

export default AboutCTA;
